import React, { useEffect, useState, useRef } from "react";
import "./Sidebar.css";
import { Container } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { AiFillHome } from "react-icons/ai";
import { IoIosPeople } from "react-icons/io";
import { BsFillCartCheckFill } from "react-icons/bs";
import { MdCreditScore } from "react-icons/md";
import { RiFolderTransferLine } from "react-icons/ri";
import { IoIosLogOut } from "react-icons/io";
import { RiFundsBoxFill } from "react-icons/ri";
import { RiFundsLine } from "react-icons/ri";
import { AiTwotoneFund } from "react-icons/ai";
import { RiRefund2Line } from "react-icons/ri";
import { SiHiveBlockchain } from "react-icons/si";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RiExchangeFundsLine } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { RiUserSettingsFill } from "react-icons/ri";
import { GiLetterBomb } from "react-icons/gi";
import { SiBnbchain } from "react-icons/si";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";
import { FaMoneyBillAlt, FaMoneyCheckAlt } from "react-icons/fa";
import NavPages from "../NavPages";
import { BsHddStackFill } from "react-icons/bs";
import Change from "../Common/StringToSub";
import useWindowDimensions from "../Common/useWindowDimensions";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { Data } from "../Common/Data";
import { IoQrCodeSharp } from "react-icons/io5";
import { BsBank2 } from "react-icons/bs";
import { IoNewspaperOutline, IoAddCircleOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { MdVerified } from "react-icons/md";
import { MyDelay } from "../Common/Data";
import { BiMoneyWithdraw } from "react-icons/bi";
import { GiTakeMyMoney } from "react-icons/gi";
import { TbReportMoney } from "react-icons/tb";
import { fetchDashboardData } from "../Actions/adminActions";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaTrophy } from "react-icons/fa";
import { IoCopy } from "react-icons/io5";
import CopyFromtag from "../Common/CopyFromtag";
import ConnectButton from "../Component/ConnectButton";
import { logout } from "../Actions/adminActions";
import { RiUserSharedLine } from "react-icons/ri";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaMoneyCheck } from "react-icons/fa6";
import { CiMoneyBill } from "react-icons/ci";
import { FaTowerBroadcast } from "react-icons/fa6";
import { TbMoneybag } from "react-icons/tb";
import { fetchApiRoutes } from "../Actions/adminActions";
import routesData from "./Routes.json";
import { GiWallet } from "react-icons/gi";
import WalletButton from "../Component/WalletButton";
import ThemeToggle from "../Component/ThemeToggle/ThemeToggle";
import AdminBrand from "../Component/AdminBrand/AdminBrand";

const Sidebar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { loading, error, user } = useSelector((state) => state.admin);
  const { routes } = useSelector((state) => state.admin);
  const [permissions, setPermissions] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    if (error?.code === 419) {
      navigate("/");
    }
  }, [error]);
  // const acc = useSelector((state) => state.account.value);

  const userAddress = localStorage.getItem("userAddress");
  const [openDropdown, setOpenDropdown] = useState(null);
  const { height, width } = useWindowDimensions();
  const hasFetchedData = useRef(false);
  const [toggle, setToggle] = useState("0");

  useEffect(() => {
    if (width < 900) {
      setToggle("-272px");
    } else {
      setToggle("0");
    }
  }, [width]);

  async function Logout() {
    await MyDelay(500);
    dispatch(logout()); // Dispatch the logout action
    navigate("/", { replace: true });
  }

  useEffect(() => {
    if (error?.code === 419) {
      navigate("/", { replace: true });
    }
  }, [error, navigate]);

  var x = 0;
  useEffect(() => {
    if (x === 0) dispatch(fetchApiRoutes());
    x++;
  }, [dispatch]);

  useEffect(() => {
    if (routes?.routes?.length > 0) {
      const updatedPermissions = {};
      // console.log("local routes", routesData);
      routesData.forEach((localRoute) => {
        // console.log("api routes", routes);
        const match = routes?.routes.find(
          (apiRoute) =>
            apiRoute.path === localRoute.path &&
            apiRoute.showInMenu === localRoute.showInMenu,
        );

        if (match) {
          // console.log(`Matched Route:`, localRoute.path);
          updatedPermissions[localRoute.stateKey] = true; // Enable section
        }
      });
      console.log("updatedPermissions", updatedPermissions);
      setPermissions(updatedPermissions);
      // console.log(permissions);
    }
  }, [routes]);

  const { dashboardData } = useSelector((state) => state.admin);
  useEffect(() => {
    if (!hasFetchedData.current) {
      dispatch(fetchDashboardData());
      hasFetchedData.current = true;
    }
  }, []);
  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown((prevState) =>
      prevState === dropdownName ? null : dropdownName,
    );
  };

  const section = location.pathname
    .replace(/^\/dashboard\/?/, "")
    .split("/")
    .filter(Boolean)[0];
  const pageTitle = section ? section.replace(/[_-]/g, " ") : "Dashboard";

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <div id="sidebar-wrapper" className="" style={{ left: toggle }}>
          <AdminBrand
            variant="sidebar"
            onNavigate={() => (width < 800 ? setToggle("-272px") : undefined)}
          />
          <section className="sidebar-nav-section">
            <div className="sidebar-user-card">
              <h3 className="m-0">
                Admin <span className="status-dot" aria-hidden="true" />
              </h3>
              <p>{Change(userAddress)}</p>
            </div>
            {permissions?.setDashboard && (
              <NavLink
                to=""
                end
                activeClassName="active"
                onClick={() => (width < 800 ? setToggle("-272px") : "")}
              >
                <div className="items">
                  <i>
                    <AiFillHome />
                  </i>
                  <h4 className="m-0">Dashboard</h4>
                </div>
              </NavLink>
            )}
            {permissions?.setUsers && (
              <div
                className="dropdownitems"
                onClick={() => handleDropdownToggle("users")}
              >
                <div className={`head items`}>
                  <i>
                    <IoIosPeople />
                  </i>
                  <h4 className="m-0">Users</h4>
                  <i
                    className="dropicon"
                    style={{
                      transform: `rotate(${
                        openDropdown === "users" ? "180deg" : "0deg"
                      })`,
                    }}
                  >
                    <BsChevronDown />
                  </i>
                </div>
                {openDropdown === "users" && (
                  <div className="dropdown">
                    {permissions?.setUsers && (
                      <NavLink
                        to="all_users"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <GiLetterBomb />
                          </i>
                          <h4 className="m-0">All Users</h4>
                        </div>
                      </NavLink>
                    )}
                    {/* {permissions?.setUsers && (
                      <NavLink
                        to="package_purchase"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <BsFillCartCheckFill />
                          </i>
                          <h4 className="m-0">Top Up</h4>
                        </div>
                      </NavLink>
                    )} */}
                    {/* Title Ranks hidden
                    {permissions?.setGetRanks && (
                      <NavLink
                        to="royalty"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <FaGifts />
                          </i>
                          <h4 className="m-0">Title Ranks</h4>
                        </div>
                      </NavLink>
                    )}
                    */}
                    {/* {permissions?.setPaymentTransactions && (
                      <NavLink
                        to="user_added_fund_history"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <RiFundsLine />
                          </i>
                          <h4 className="m-0">User Added Funds with DAP</h4>
                        </div>
                      </NavLink>
                    )} */}
                    {/*{permissions?.setUplineBonus && (
                      <NavLink
                        to="upline_bonus"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <FaTrophy />
                          </i>
                          <h4 className="m-0">Upline Bonus</h4>
                        </div>
                      </NavLink>
                    )} */}
                    {/* <NavLink
                    to="top_up"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdCreditScore />
                      </i>
                      <h4 className="m-0">Top Up</h4>
                    </div>
                  </NavLink> */}
                    {/* <NavLink
                    to="give_power"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiFolderTransferLine />
                      </i>
                      <h4 className="m-0">Give Power</h4>
                    </div>
                  </NavLink> */}

                    {/* <NavLink
                    to="add_capping"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <CiMoneyBill />
                      </i>
                      <h4 className="m-0">Add Capping</h4>
                    </div>
                  </NavLink> */}

                    {/* <NavLink
                    to="royalty"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaGifts />
                      </i>
                      <h4 className="m-0">Royalty</h4>
                    </div>
                  </NavLink> */}
                  </div>
                )}
              </div>
            )}

            {/* {permissions?.setFunds && (
              <NavLink
                to="chain"
                activeClassName="active"
                onClick={(e) => {
                  e.stopPropagation();
                  if (width < 800) {
                    setToggle("-272px");
                  }
                }}
              >
                <div className="items">
                  <i>
                    <RiRefund2Line />
                  </i>
                  <h4 className="m-0">Web3 Address</h4>
                </div>
              </NavLink>
            )} */}

            {/* <NavLink
              to="kyc_detail"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-272px");
                }
              }}
            >
              <div className="items">
                <i>
                  <MdVerified />
                </i>
                <h4 className="m-0">KYC</h4>
              </div>
            </NavLink> */}

            {/* <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("bank")}
            >
              <div className={`head items`}>
                <i>
                  <FaMoneyBillAlt />
                </i>
                <h4 className="m-0">Bank Reports</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "bank" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "bank" && (
                <div className="dropdown">
                  {/* <NavLink
                    to="bank"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BsBank2 />
                      </i>
                      <h4 className="m-0">Bank Details</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="select_upi"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoQrCodeSharp />
                      </i>
                      <h4 className="m-0">UPI</h4>
                    </div>
                  </NavLink> */}
            {/* <NavLink
                    to="chain"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <SiBnbchain />
                      </i>
                      <h4 className="m-0">Web3</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div> */}

            <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("funds")}
            >
              <div className={`head items`}>
                <i>
                  <AiOutlineFundProjectionScreen />
                </i>
                <h4 className="m-0">Funds</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countPendingPaymentRequests === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {/* {dashboardData?.countPendingPaymentRequests} */}
                </div>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "funds" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "funds" && (
                <div className="dropdown">
                  {/* <NavLink
                    to="fund_controls"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiFundsBoxFill />
                      </i>
                      <h4 className="m-0">Fund Request</h4>
                    </div>
                  </NavLink> */}
                  {/* {permissions?.setPaymentsMethod && (
                    <NavLink
                      to="chain"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <SiBnbchain />
                        </i>
                        <h4 className="m-0">Payment Addresses</h4>
                      </div>
                    </NavLink>
                  )} */}
                  {permissions?.setFunds && (
                    <NavLink
                      to="add_fund"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <RiRefund2Line />
                        </i>
                        <h4 className="m-0">Add Funds</h4>
                      </div>
                    </NavLink>
                  )}
                  <NavLink
                    to="add_fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiFundsLine />
                      </i>
                      <h4 className="m-0">Add Funds History</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="retrieve_fund"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiExchangeFundsLine />
                      </i>
                      <h4 className="m-0">Retrieve Fund </h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="retrieve_fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <TbReportMoney />
                      </i>
                      <h4 className="m-0">Retrieve Fund History</h4>
                    </div>
                  </NavLink>
                  {/* <NavLink
                    to="fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiLetterBomb />
                      </i>
                      <h4 className="m-0">Funds History</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="fund_transfer_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BiTransferAlt />
                      </i>
                      <h4 className="m-0">Funds Transfer History</h4>
                    </div>
                  </NavLink> */}
                </div>
              )}
            </div>
            {permissions?.setPaymentTransactions && (
              <NavLink
                to="withdraw_controls"
                activeClassName="active"
                onClick={(e) => {
                  e.stopPropagation();
                  if (width < 800) {
                    setToggle("-272px");
                  }
                }}
              >
                <div className="items">
                  <i>
                    <BiMoneyWithdraw />
                  </i>
                  <h4 className="m-0">Withdrawal</h4>
                  <div
                    className="reminder"
                    style={{
                      backgroundColor:
                        dashboardData?.countPendingWithdrawals === 0
                          ? "green"
                          : "red",
                    }}
                  >
                    {dashboardData?.countPendingWithdrawals}
                  </div>
                </div>
              </NavLink>
            )}
            {/*<NavLink
              to="contract_withdrawal"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-272px") : "")}
            >
              <div className="items">
                <i>
                  <SiHiveBlockchain />
                </i>
                <h4 className="m-0">Contract Withdrawal</h4>
              </div>
            </NavLink>*/}
            {permissions?.setIncomes && (
              <NavLink
                to="payout_controls"
                activeClassName="active"
                onClick={() => (width < 800 ? setToggle("-272px") : "")}
              >
                <div className="items">
                  <i>
                    <FaMoneyCheckAlt />
                  </i>
                  <h4 className="m-0">Payout Report</h4>
                </div>
              </NavLink>
            )}
            {/* Closing link hidden
            {permissions?.setIncomes && (
              <NavLink
                to="closing_link"
                activeClassName="active"
                onClick={() => (width < 800 ? setToggle("-272px") : "")}
              >
                <div className="items">
                  <i>
                    <TbReportMoney />
                  </i>
                  <h4 className="m-0">Closing link</h4>
                </div>
              </NavLink>
            )}
            */}
            {/* <NavLink
              to="release_income_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-272px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheck />
                </i>
                <h4 className="m-0">Release Income</h4>
              </div>
            </NavLink> */}
            {permissions?.setAllOrders && (
              <NavLink
                to="orders"
                activeClassName="active"
                onClick={() => (width < 800 ? setToggle("-272px") : "")}
              >
                <div className="items">
                  <i>
                    <BsFillCartCheckFill />
                  </i>
                  <h4 className="m-0">Orders</h4>
                </div>
              </NavLink>
            )}
            {(permissions?.setAddNews || permissions?.setNews) && (
              <div
                className="dropdownitems"
                onClick={() => handleDropdownToggle("news")}
              >
                <div className="head items">
                  <i>
                    <IoNewspaperOutline />
                  </i>
                  <h4 className="m-0">News</h4>
                  <i
                    className="dropicon"
                    style={{
                      transform: `rotate(${
                        openDropdown === "news" ? "180deg" : "0deg"
                      })`,
                    }}
                  >
                    <BsChevronDown />
                  </i>
                </div>
                {openDropdown === "news" && (
                  <div className="dropdown">
                    {(permissions?.setAddNews || permissions?.setNews) && (
                      <NavLink
                        to="add_news"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <IoAddCircleOutline />
                          </i>
                          <h4 className="m-0">Add News</h4>
                        </div>
                      </NavLink>
                    )}
                    {permissions?.setNews && (
                      <NavLink
                        to="news"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <IoNewspaperOutline />
                          </i>
                          <h4 className="m-0">News</h4>
                        </div>
                      </NavLink>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* <NavLink
              to="user_register
              "
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-272px");
                }
              }}
            >
              <div className="items">
                <i>
                  <RiUserSharedLine />
                </i>
                <h4 className="m-0">User Register</h4>
              </div>
            </NavLink> */}

            {/*<NavLink
              to="sip_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-272px") : "")}
            >
              <div className="items">
                <i>
                  <GiReceiveMoney />
                </i>
                <h4 className="m-0">SIP</h4>
              </div>
            </NavLink>

            <NavLink
              to="installment_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-272px") : "")}
            >
              <div className="items">
                <i>
                  <GiTakeMyMoney />
                </i>
                <h4 className="m-0">Installment Status</h4>
              </div>
            </NavLink>*/}
            {permissions?.setAllTickets && (
              <NavLink
                to="support"
                activeClassName="active"
                onClick={() => (width < 800 ? setToggle("-272px") : "")}
              >
                <div className="items">
                  <i>
                    <MdOutlineSupportAgent />
                  </i>
                  <h4 className="m-0">Support</h4>
                </div>
              </NavLink>
            )}
            {permissions?.setUplineBonus && (
              <div
                className="dropdownitems"
                onClick={() => handleDropdownToggle("settings")}
              >
                <div className={`head items`}>
                  <i>
                    <IoMdSettings />
                  </i>
                  <h4 className="m-0">Settings</h4>
                  <i
                    className="dropicon"
                    style={{
                      transform: `rotate(${
                        openDropdown === "settings" ? "180deg" : "0deg"
                      })`,
                    }}
                  >
                    <BsChevronDown />
                  </i>
                </div>
                {openDropdown === "settings" && (
                  <div className="dropdown">
                    {/* <NavLink
                    to="general-settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiUserSettingsFill />
                      </i>
                      <h4 className="m-0">General Setting</h4>
                    </div>
                  </NavLink> */}
                    {/* {permissions?.setCompanyInfo && (
                  <NavLink
                    to="coin_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BsHddStackFill />
                      </i>
                      <h4 className="m-0">Coin Setting</h4>
                    </div>
                  </NavLink>
                  )}
                  {permissions?.setBroadCastInfo && (
                  <NavLink
                    to="broadcastInfo"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaTowerBroadcast />
                      </i>
                      <h4 className="m-0">Broadcast Info Setting</h4>
                    </div>
                  </NavLink>
                  )}
                  {permissions?.setCompanyInfo && (
                    <NavLink
                      to="principal_withdrawal_setting"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <GiWallet />
                        </i>
                        <h4 className="m-0">Principal Withdrawal Status</h4>
                      </div>
                    </NavLink>
                  )}
                  <NavLink
                    to="bonus_income_setting"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-272px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <TbMoneybag />
                      </i>
                      <h4 className="m-0">Bonus Income Setting</h4>
                    </div>
                  </NavLink>
                   {permissions?.setRoutesByRole && (
                  <NavLink
                      to="role_settings"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <MdOutlineSettingsSuggest />
                        </i>
                        <h4 className="m-0">Role Settings</h4>
                      </div>
                    </NavLink>
                    )} */}

                    {/* <NavLink
                      to="reward_settings"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <FaTrophy />
                        </i>
                        <h4 className="m-0">Reward Settings</h4>
                      </div>
                    </NavLink> */}
                    <NavLink
                      to="income_setting"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <TbMoneybag />
                        </i>
                        <h4 className="m-0">Income Setting</h4>
                      </div>
                    </NavLink>
                    <NavLink
                      to="closing"
                      activeClassName="active"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (width < 800) {
                          setToggle("-272px");
                        }
                      }}
                    >
                      <div className="items">
                        <i>
                          <TbReportMoney />
                        </i>
                        <h4 className="m-0">Closing</h4>
                      </div>
                    </NavLink>
                    {permissions?.setChangePassword && (
                      <NavLink
                        to="change_password"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <RiLockPasswordFill />
                          </i>
                          <h4 className="m-0">Change Password</h4>
                        </div>
                      </NavLink>
                    )}
                    {/* {permissions?.setChangePassword && (
                      <NavLink
                        to="update_bonus_income"
                        activeClassName="active"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (width < 800) {
                            setToggle("-272px");
                          }
                        }}
                      >
                        <div className="items">
                          <i>
                            <TbMoneybag />
                          </i>
                          <h4 className="m-0">Update Bonus Income</h4>
                        </div>
                      </NavLink>
                    )} */}
                  </div>
                )}
              </div>
            )}

            <div className="items" onClick={Logout}>
              <i>
                <IoIosLogOut />
              </i>
              <h4 className="m-0">Logout</h4>
            </div>
          </section>
        </div>
        <div
          id="page-content"
          className={`p-0${width > 900 && toggle !== "-272px" ? " page-content-shifted" : ""}`}
        >
          <div className="navMain">
            <header className="topNavbar">
              <div className="topNavbar-start">
                <button
                  type="button"
                  className="topNavbar-menu-btn"
                  aria-label="Toggle navigation menu"
                  onClick={() =>
                    toggle === "-272px" ? setToggle("0") : setToggle("-272px")
                  }
                >
                  <GiHamburgerMenu />
                </button>
                <p className="topNavbar-title">{pageTitle}</p>
              </div>
              <div className="topNavbar-actions">
                <WalletButton />
                <ThemeToggle />
              </div>
            </header>
          </div>

          <div className="page-main-content">{<NavPages />}</div>
        </div>
      </Container>
    </React.Fragment>
  );
};
// const Sidebar = withRouter(Side);
export default Sidebar;
